import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { Grid } from '@material-ui/core'

import { LabeledIOSSwitch } from '../../LabeledIOSSwitch'

import { useApi } from '../../../hooks/storeHook'
import { useBoolState } from '../../../hooks/commonHooks'
import { useMessages } from '../../../hooks/snackbarHooks'
import { useSettingsPageStyles } from '../../../hooks/settingsPageStylesHook'

import { YmAccountProps } from '../../../types/accountProps'

export const YandexMarketUnifiedPricesToggle =
  observer(
    ({account}: YmAccountProps) => {
      const classes = useSettingsPageStyles()

      const {userSync: {setYandexMarketUsingUnifiedPrices}} = useApi()
      const {showSuccess, showError} = useMessages()

      const [usingUnifiedPrices, setUsingUnifiedPrices] = useState(account.usingUnifiedPrices)
      const [isSaving, setSaving, setSaved] = useBoolState(false)

      const onToggle = async () => {
        if (isSaving) {
          return
        }

        setSaving()

        const newValue = !usingUnifiedPrices
        setUsingUnifiedPrices(newValue)

        try {
          await setYandexMarketUsingUnifiedPrices({accountId: account.id, isEnabled: newValue})
          account.usingUnifiedPrices = newValue
          showSuccess('Сохранено!')
        } catch (e) {
          console.error('Failed to save usingUnifiedPrices', e)
          setUsingUnifiedPrices(!newValue)
          showError('Не удалось сохранить настройку!')
        } finally {
          setSaved()
        }
      }

      return (
        <Grid container className={clsx(classes.settingsTopic, 'default-border')}>
          <Grid item xs={12} className={classes.root}>
            <LabeledIOSSwitch
              label="Настройка работ с ценами"
              switchLabel="Использовать общие цены"
              checked={usingUnifiedPrices}
              onChange={onToggle}
              helperText="Используется для передачи дополнительных ценовых параметров в Yandex.Market, например, минимальной цены. Включайте эту настройку, только если в ваших магазинах Yandex.Market используются общие цены."
            />
          </Grid>
        </Grid>
      )
    })